<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Content</label>
          <v-row>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="text-color"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['text-color']"
                      @change="handleChangeTextColor"
                    />
                    <v-text-field v-model="fields['text-color']" label="Text Color" />
                    <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="6">
              <div style="margin-bottom: 20px">
                <div>
                  <div class="d-flex align-center gap-3">
                    <input
                      type="color"
                      name="card-container"
                      style="width: 40px; height: 40px; margin-right: 12px"
                      :value="fields['card-container']"
                      @change="handleChangeBg($event)"
                    />
                    <v-text-field v-model="fields['card-container']" label="Background Color" />
                    <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <div style="margin-bottom: 20px">
            <label class="label-input">Pagination Colors</label>
            <v-row>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-active-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-active-color']"
                        @change="handleChangePaginationActiveColor"
                      />
                      <v-text-field v-model="fields['pagination-active-color']" label="Pagination Active Color" />
                      <v-btn @click="handleResetPaginationActiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div style="margin-bottom: 20px">
                  <div>
                    <div class="d-flex align-center gap-3">
                      <input
                        type="color"
                        name="pagination-inactive-color"
                        style="width: 40px; height: 40px; margin-right: 12px"
                        :value="fields['pagination-inactive-color']"
                        @change="handleChangePaginationInactiveColor"
                      />
                      <v-text-field v-model="fields['pagination-inactive-color']" label="Pagination Inactive Color" />
                      <v-btn @click="handleResetPaginationInactiveColor" small text color="primary"> Reset </v-btn>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label style="margin-bottom: 0">Icon With Text</label>
            </div>
            <v-btn small text color="primary" @click="handleAddIconWithText">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Icon With Text</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="i">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Icon With Text {{ i + 1 }}</span>
                  <v-btn icon @click.stop="handleRemoveIconWithText(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="">
                  <div class="mb-5">
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, i)"
                      :image="{ imageSrc: item.image }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUpload(i)"
                    />
                  </div>
                  <!-- <v-text-field outlined v-model="item.title" label="Title" type="text" /> -->
                  <label>Text</label>
                  <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'icon-with-text-slider-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        'text-color': '',
        'card-container': '',
        'list-item': [],
        'pagination-active-color': '',
        'pagination-inactive-color': '',
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionIconWithTextSlider(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddIconWithText() {
      this.fields['list-item'].push({ image: '', text: '' });
    },
    handleRemoveIconWithText(index) {
      this.fields['list-item'].splice(index, 1);
    },
    handleUploadImage(obj, index) {
      this.fields['list-item'][index].image = obj.imageSrc;
    },
    handleRemoveUpload(index) {
      this.fields['list-item'][index].image = '';
    },
    handleChangeBg(event) {
      this.fields['card-container'] = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleResetTextColor() {
      this.fields['text-color'] = '';
    },
    handleResetBackgroundColor() {
      this.fields['card-container'] = '';
    },
    handleChangePaginationActiveColor(event) {
      this.fields['pagination-active-color'] = event.target.value;
    },
    handleResetPaginationActiveColor() {
      this.fields['pagination-active-color'] = '';
    },
    handleChangePaginationInactiveColor(event) {
      this.fields['pagination-inactive-color'] = event.target.value;
    },
    handleResetPaginationInactiveColor() {
      this.fields['pagination-inactive-color'] = '';
    },
  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 300px;
}
.ck-editor__editable {
  min-height: 300px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
